import type {VehicleCheckOutcome} from "../types";

export const VEHICLE_CHECK_OUTCOMES: VehicleCheckOutcome[] = [
  "no_action",
  "citation_issued",
  "stored_tracking",
  "unknown_vehicle",
];

export const VEHICLE_CHECK_OUTCOME_LABELS: Record<VehicleCheckOutcome, string> = {
  no_action: "No action",
  citation_issued: "Citation issued",
  stored_tracking: "Stored vehicle tracking",
  unknown_vehicle: "Unknown vehicle",
};

export const VEHICLE_CHECK_RECOGNITION_STATUS_LABELS: Record<string, string> = {
  pending: "Pending",
  recognized: "Recognized",
  succeeded: "Recognized",
  manual: "Manual",
  unreadable: "Unreadable",
  unprocessable: "Unprocessable",
  failed: "Failed",
  ai_unavailable: "AI unavailable",
};

export const VEHICLE_CHECK_MAP_PAGE_LIMIT = 15;

export const VEHICLE_CHECK_QUERY_KEYS = {
  list: "vehicle-checks",
  infinite: "infinite-vehicle-checks",
  detail: "vehicle-check",
  map: "vehicle-checks-map",
  outsideShiftCount: "vehicle-checks-outside-shift-count",
} as const;

export const VEHICLE_CHECK_ERROR_CODES = {
  unreadable: "PLATE_UNREADABLE",
  unprocessable: "PLATE_IMAGE_UNPROCESSABLE",
  aiUnavailable: "AI_UNAVAILABLE",
} as const;
